import React, { useEffect } from "react";
import ECHOcon from "./ECHOcon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function ECHO() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <ECHOcon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Echo Service in Whitefield</title>
        <meta
          name="description"
          content="We provide the best Echo Service in Whitefield and Vijayanagar. Contact us today if you are looking for this or call us now."
        />
        <meta
          name="keywords"
          content="Best Echo Service in Whitefield, Best Echo Service in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestechoservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestechoservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers expert echo (echocardiography) services including heart function evaluation, diagnostic cardiac imaging, stress echo, and comprehensive cardiovascular assessments performed by skilled technicians and cardiology specialists.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Echocardiography diagnostic imaging",
              "Heart function evaluation",
              "Stress echo testing",
              "Cardiac chamber and valve assessment",
              "Real-time cardiac motion imaging",
              "Cardiovascular risk evaluation",
            ],
            keywords: [
              "best echo services in Immadihalli",
              "best echo services in Whitefield",
              "best echo services in Bangalore",
              "best echo services in Kundalahalli",
              "best echo services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best Echo Service in Whitefield promoting the overall well-being of our
        patients. Contact us for the best Echo Service in Whitefield.
      </h2>
      <Servicebanner name="ECHO" banner={"../photo/dd7.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
                <Divider />
              </div>
              <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default ECHO;
